<template>
    <footer class="footer">
        <section class="container">
          <div style="text-align: center" class="footer--logo">
            <!-- logo -->
            <router-link :to="'/'">
              <img class="logo-twegos" src="../assets/Bottom_logo_baseline.png" alt="Trucker Matching by Twegos">
            </router-link>
            <!-- @end logo -->
          </div>
          <section class="footer--navigation" >
            <div v-for="(footers, index) in data.footer" :key="index" class="item--navigation">
                <router-link :to="footers.url">  
                  <h3>{{ footers.title }}</h3>
                </router-link>
                <ul>    
                <template v-for="(item, index) in footers.navItems">
                  <li v-if="item.external==1"><a v-if="item.external==1" target="_blank" style="color:white;text-decoration:none" :href="item.links">{{ item.name }}</a></li>
                  <router-link  v-else :key="index" :to="item.links" tag="li">
                      <a :href="item.links" >{{item.name}}</a>
                  </router-link>
                </template>
                </ul>
            </div>
          </section>
        </section>
    </footer>
    
</template>

<script>
import Common from '@/contents/common.json'

export default {
  name: 'SectionFooter',
  data () {
    return {
      'data': Common
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue